import { RadialBar, RadialBarChart, ResponsiveContainer, PolarAngleAxis } from "recharts";
import BilingualText from "@/components/BilingualText";
import { t } from "@/lib/i18n";
import { IDS } from "@/constants/testIds";

/** Circular gauge for CEQ readiness (0–100). */
export function ReadinessMeter({ value = 0, size = 220, subtitle }) {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  const level =
    pct >= 80 ? { cn: "非常棒！", en: "Ready", color: "#10b981" } :
    pct >= 60 ? { cn: "接近达标", en: "Almost there", color: "#3b82f6" } :
    pct >= 40 ? { cn: "继续加油", en: "Keep going", color: "#f59e0b" } :
                { cn: "刚起步", en: "Just starting", color: "#f97316" };

  const data = [{ name: "readiness", value: pct, fill: level.color }];

  return (
    <div
      data-testid={IDS.dashboard.readinessMeter}
      className="card-plush p-6 flex flex-col items-center gap-2"
    >
      <BilingualText cn={t.readiness_meter.cn} en={t.readiness_meter.en} size="md" />
      <div style={{ width: size, height: size }} className="relative">
        <ResponsiveContainer>
          <RadialBarChart
            innerRadius="72%"
            outerRadius="100%"
            data={data}
            startAngle={90}
            endAngle={-270}
            barSize={16}
          >
            <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
            <RadialBar
              minAngle={2}
              background={{ fill: "#eef2f7" }}
              clockWise
              dataKey="value"
              cornerRadius={20}
            />
          </RadialBarChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 grid place-items-center">
          <div className="flex flex-col items-center">
            <span className="serif text-5xl font-black text-slate-900">{pct}</span>
            <span className="text-xs font-semibold text-slate-400 uppercase tracking-widest">
              / 100
            </span>
          </div>
        </div>
      </div>
      <div
        className="badge-soft"
        style={{ background: `${level.color}22`, color: level.color }}
      >
        <span className="cn">{level.cn}</span>
        <span>· {level.en}</span>
      </div>
      {subtitle && <p className="text-xs text-slate-400 mt-1">{subtitle}</p>}
    </div>
  );
}

export default ReadinessMeter;
